<template>
  <div id="app">
    <router-view class="appRouter" />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  mounted() {
    const _this = this;
    _this.$store.state.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      _this.$store.state.screenWidth = document.body.clientWidth;
    };
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  watch: {
    $route(to, form) {},
  },
};
</script>
<style scoped>
.appRouter {
  position: relative;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background: #fff;
  overflow-y: auto;
}
</style>
<style lang="less">
@import "../static/css/common";
</style>



// WEBPACK FOOTER //
// src/App.vue